import React, { useState } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { Input } from '@planne-software/uni/Input';

import { useTranslate } from '@src/core/hooks';

import { PasswordSuffixButton } from '../styles';
import type { SignupFormValues } from '../hooks/useSignupForm/signupSchema';

const FIELDS = [
  { name: 'password', labelKey: 'checkout_auth_password_label', hintKey: 'checkout_auth_signup_password_hint' },
  {
    name: 'passwordConfirmation',
    labelKey: 'checkout_auth_signup_password_confirmation_label',
    hintKey: 'checkout_auth_signup_password_confirmation_hint',
  },
] as const;

type PasswordFieldsProps = {
  control: Control<SignupFormValues>;
  disabled?: boolean;
};

export const PasswordFields = (props: PasswordFieldsProps) => {
  const { control, disabled } = props;
  const { i18n } = useTranslate();
  const [visible, setVisible] = useState(false);

  return (
    <>
      {FIELDS.map(({ name, labelKey, hintKey }) => (
        <Controller
          key={name}
          name={name}
          control={control}
          render={({ field: { onChange, onBlur, value, ref }, fieldState }) => (
            <Input
              type={visible ? 'text' : 'password'}
              name={name}
              id={name}
              label={i18n(labelKey)}
              value={value ?? ''}
              onChange={onChange}
              onBlur={onBlur}
              error={!!fieldState.error}
              helperText={fieldState.error?.message ?? i18n(hintKey)}
              autoComplete='new-password'
              disabled={disabled}
              required
              ref={ref}
              size='medium'
              fullWidth
              suffixSlot={
                <PasswordSuffixButton
                  type='button'
                  onClick={() => setVisible((previous) => !previous)}
                  aria-label={visible ? i18n('checkout_auth_hide_password') : i18n('checkout_auth_show_password')}
                >
                  {visible ? <IconEyeOff size={20} aria-hidden /> : <IconEye size={20} aria-hidden />}
                </PasswordSuffixButton>
              }
            />
          )}
        />
      ))}
    </>
  );
};

export default PasswordFields;
